<template>
  <div class="nlp__who-is-for-box">
    <h2>
      Who It Is For
    </h2>
    <div class="nlp__who-is-for-header">
      <div class="nlp__who-is-for-header-icon">
        <NlpWhoIsForIcon4 />
      </div>
      <div
        v-if="!isNlpMobile"
        class="nlp__who-is-for-header-lines"
      >
        <NlpWhoIsForLinesDesktop v-if="isNlpDesktop" />
        <NlpWhoIsForLinesTablet v-else-if="isNlpTablet" />
      </div>
    </div>
    <div class="nlp__who-is-for-cards">
      <div
        v-for="(item, index) in whoIsForData"
        :key="index"
        class="nlp__who-is-for-card"
      >
        <div class="nlp__who-is-for-card-title">
          {{ item.title }}
        </div>
        <div class="nlp__who-is-for-card-icon">
          <component :is="item.icon" />
        </div>
        <div class="nlp__who-is-for-card-text">
          <p>
            {{ item.description }}
          </p>
        </div>
      </div>
    </div>
    <div class="nlp__button-box">
      <NlpButton
        primary
        text="Scan Address"
        @button-click="$router.push({ name: 'source-of-funds' })"
      />
    </div>
  </div>
</template>

<script>
// Components
import NlpWhoIsForIcon1 from '@/pages/landing-page/svg/NlpWhoIsForIcon1.vue'
import NlpWhoIsForIcon2 from '@/pages/landing-page/svg/NlpWhoIsForIcon2.vue'
import NlpWhoIsForIcon3 from '@/pages/landing-page/svg/NlpWhoIsForIcon3.vue'
import NlpWhoIsForIcon4 from '@/pages/landing-page/svg/NlpWhoIsForIcon4.vue'
import NlpWhoIsForLinesDesktop from '@/pages/landing-page/svg/NlpWhoIsForLinesDesktop.vue'
import NlpWhoIsForLinesTablet from '@/pages/landing-page/svg/NlpWhoIsForLinesTablet.vue'
import NlpButton from '@/pages/landing-page/ui-components/NlpButton.vue'

// Mixins
import deviceWidthMixin from '@/assets/mixins/deviceWidthMixin.js'

export default {
  name: 'NlpWhoIsFor',
  components: {
    NlpWhoIsForIcon1,
    NlpWhoIsForIcon2,
    NlpWhoIsForIcon3,
    NlpWhoIsForIcon4,
    NlpWhoIsForLinesDesktop,
    NlpWhoIsForLinesTablet,
    NlpButton,
  },
  mixins: [deviceWidthMixin],
  data() {
    return {
      whoIsForData: [
        {
          title: 'OTC Trader',
          icon: NlpWhoIsForIcon1,
          description: 'I run an OTC desk. Before settling any deal, I always check wallets first, just to avoid trouble later.',
        },
        {
          title: 'Crypto Investor',
          icon: NlpWhoIsForIcon2,
          description: 'I invest in crypto projects. I scan their wallets to see if there’s anything suspicious before putting my money in.',
        },
        {
          title: 'Freelancer',
          icon: NlpWhoIsForIcon3,
          description: 'I’m a freelancer. Before I accept payments in crypto, I check the sender’s wallet to make sure it’s not linked to anything shady.',
        },
      ],
    }
  },
}
</script>

<style scoped>
.nlp__who-is-for-box h2 {
  margin-bottom: 60px;
}

.nlp__who-is-for-header {
  position: relative;
}
.nlp__who-is-for-header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  margin: 0 auto;
  background-color: #194BFB;
  border: 1px solid #D9E1F1;
  border-radius: 100%;
}
.nlp__who-is-for-header-lines {
  height: 92px;
  position: relative;
  z-index: 1;
}
.nlp__who-is-for-header-lines svg {
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0);
  z-index: 1;
}

.nlp__who-is-for-cards {
  display: flex;
  gap: 66px;
  flex-wrap: wrap;
}
.nlp__who-is-for-card {
  flex: 1;
  min-width: 0;
  padding: 4px;
  background-color: #fff;
  border: 1px solid #E2E9F6;
  border-radius: 24px;
  box-shadow: 2px 2px 4px 0px #B8C2DB40;
  position: relative;
  z-index: 2;
}
.nlp__who-is-for-card:nth-child(1) {
    order: 1;
  }
  .nlp__who-is-for-card:nth-child(2) {
    order: 2;
  }
  .nlp__who-is-for-card:nth-child(3) {
    order: 3;
  }
.nlp__who-is-for-card-title {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 76px;
  background-color: #194BFB;
  border-radius: 18px;
  font-weight: 700;
  font-size: 18px;
  line-height: 26px;
  color: #fff;
}
.nlp__who-is-for-card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  margin: -24px 0 8px 20px;
  border: 2px solid #fff;
  border-radius: 100%;
}
.nlp__who-is-for-card:nth-child(1) .nlp__who-is-for-card-icon {
  background-color: #6631D4;
}
.nlp__who-is-for-card:nth-child(2) .nlp__who-is-for-card-icon {
  background-color: #FFA305;
}
.nlp__who-is-for-card:nth-child(3) .nlp__who-is-for-card-icon {
  background-color: #F1104E;
}
.nlp__who-is-for-card-text {
  padding: 0 20px 20px 20px;
}
.nlp__who-is-for-card-text p {
  font-size: 16px;
}


@media (max-width: 1279px) {
  .nlp__who-is-for-cards {
    justify-content: center;
    gap: 40px 60px;
  }
  .nlp__who-is-for-card {
    flex: 1;
    max-width: 286px;
    min-width: 286px;
  }
  .nlp__who-is-for-card:nth-child(1) {
    order: 1;
  }
  .nlp__who-is-for-card:nth-child(2) {
    order: 3;
  }
  .nlp__who-is-for-card:nth-child(3) {
    order: 2;
  }
}
@media (max-width: 767px) {
  .nlp__who-is-for-header-icon {
    margin-bottom: 32px;
  }
  .nlp__who-is-for-cards {
    display: block;
    padding-left: 24px;
    padding-right: 24px;
    position: relative;
  }
  .nlp__who-is-for-cards:before {
    content: '';
    width: 1px;
    height: 100%;
    background-color: #E2E9F6;
    position: absolute;
    top: -32px;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 1;
  }
  .nlp__who-is-for-card {
    max-width: 100%;
    min-width: 0;
  }
  .nlp__who-is-for-card + .nlp__who-is-for-card {
    margin-top: 16px;
  }
  .nlp__who-is-for-card:nth-child(1) {
    order: 1;
  }
  .nlp__who-is-for-card:nth-child(2) {
    order: 2;
  }
  .nlp__who-is-for-card:nth-child(3) {
    order: 3;
  }
}
</style>